var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLanguage } from '../../locale';
import { useGetCustomerApi, useGetPersonApi } from '../../hooks';
import { CommonAllergy } from '../../models';
import { useSelector } from 'react-redux';
import { isFamilyMemberRegisterRequested } from '../../redux';
import { useUpdateProfileHelper } from './helpers/useUpdateProfileHelper';
import { useFamilyMemberComposer } from './useFamilyMemberComposer.facade';
import { isMinor } from '../../utils';
export var useInputAllergiesFormFacade = function (_a) {
    var onAddPress = _a.onAddPress, onNext = _a.onNext, personId = _a.personId, _b = _a.isFamilyMemberUpdate, isFamilyMemberUpdate = _b === void 0 ? false : _b, confirmAlert = _a.confirmAlert;
    var t = useLanguage()[0];
    var _c = useState(false), isParentalResponsibilitySelected = _c[0], setIsParentalResponsibilitySelected = _c[1];
    //** REDUX **//
    var isNewFamilyMember = useSelector(isFamilyMemberRegisterRequested);
    var isFamilyMember = isNewFamilyMember || isFamilyMemberUpdate;
    var _d = useState([]), selectedOptions = _d[0], setSelectedOptions = _d[1];
    var maxSelectableItemsValue = 5;
    var titleChangeValue = t('memberRegistry.inputInfiniteScrollLabelAllergies');
    var profile = useFamilyMemberComposer().profile;
    //** API **//
    var customer = useGetCustomerApi(!isFamilyMember).data;
    var person = useGetPersonApi(personId || (customer === null || customer === void 0 ? void 0 : customer.personId)).data;
    var updateProfile = useUpdateProfileHelper({
        isFamilyMember: isNewFamilyMember,
        person: person,
        customer: customer,
        confirmAlert: confirmAlert,
    }).updateProfile;
    //** DATA **//
    var isMinorPerson = useMemo(function () { return isMinor(person === null || person === void 0 ? void 0 : person.birthDate); }, [person === null || person === void 0 ? void 0 : person.birthDate]);
    var options = useMemo(function () {
        return [
            {
                type: 'default',
                label: t('memberRegistry.inputAllergiesFirstOptionLabel'),
                value: CommonAllergy.Gluten,
            },
            {
                type: 'default',
                label: t('memberRegistry.inputAllergiesSecondOptionLabel'),
                value: CommonAllergy.Soy,
            },
            {
                type: 'default',
                label: t('memberRegistry.inputAllergiesThirdOptionLabel'),
                value: CommonAllergy.DriedFruit,
            },
        ];
    }, [t]);
    useEffect(function () {
        var _a, _b;
        var objectWithAllergies = undefined;
        var isPersonAndInitialized = person && !isNewFamilyMember;
        var isFamilyMemberAndInitialized = profile && isNewFamilyMember;
        if (isPersonAndInitialized) {
            objectWithAllergies = person;
        }
        if (isFamilyMemberAndInitialized) {
            objectWithAllergies = profile;
        }
        if (objectWithAllergies === undefined)
            return;
        var selectedCommonAllergiesOptions = options.filter(function (o) { var _a; return (_a = objectWithAllergies.commonAllergies) === null || _a === void 0 ? void 0 : _a.find(function (ca) { return ca === o.value; }); });
        var customAllergyOptions = (_b = (_a = objectWithAllergies.allergies) === null || _a === void 0 ? void 0 : _a.map(function (a) { return ({
            type: 'custom',
            label: a.Ingredient.name,
            value: a.Ingredient.id,
        }); })) !== null && _b !== void 0 ? _b : [];
        setSelectedOptions(__spreadArray(__spreadArray([], selectedCommonAllergiesOptions, true), customAllergyOptions, true));
    }, [isNewFamilyMember, options, person, profile]);
    //** CALLBACK **//
    var onExpandableOptionPress = useCallback(function () {
        return onAddPress &&
            onAddPress({
                titleChange: titleChangeValue,
                maxSelectableItems: maxSelectableItemsValue,
                selectedOptions: selectedOptions,
                onConfirmSelection: setSelectedOptions,
            });
    }, [onAddPress, selectedOptions, titleChangeValue]);
    var allergiesValue = useMemo(function () {
        return selectedOptions.map(function (so) { return ({
            Ingredient: {
                id: so.value,
                name: so.label,
            },
        }); });
    }, [selectedOptions]);
    var onUpdateAllergies = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var commonAllergies, allergies;
        return __generator(this, function (_a) {
            commonAllergies = allergiesValue
                .filter(function (a) {
                return a.Ingredient.id === CommonAllergy.DriedFruit ||
                    a.Ingredient.id === CommonAllergy.Gluten ||
                    a.Ingredient.id === CommonAllergy.Soy;
            })
                .map(function (a) { return a.Ingredient.id; });
            allergies = allergiesValue.filter(function (a) {
                return a.Ingredient.id !== CommonAllergy.DriedFruit &&
                    a.Ingredient.id !== CommonAllergy.Gluten &&
                    a.Ingredient.id !== CommonAllergy.Soy;
            });
            updateProfile({ allergies: allergies, commonAllergies: commonAllergies }, onNext);
            return [2 /*return*/];
        });
    }); }, [allergiesValue, onNext, updateProfile]);
    var onPressParentalResponsibility = useCallback(function () { return setIsParentalResponsibilitySelected(function (current) { return !current; }); }, []);
    return {
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        options: options,
        onExpandableOptionPress: onExpandableOptionPress,
        onUpdateAllergies: onUpdateAllergies,
        isFamilyMember: isFamilyMember,
        isMinor: isMinorPerson,
        isParentalResponsibilitySelected: isParentalResponsibilitySelected,
        onPressParentalResponsibility: onPressParentalResponsibility,
    };
};
